<template>
    <div :class="['see_pop_right_mask', 'animated', showAnimated ? 'findinMask' : 'findOutMask']" v-if="seePopRightOkShow">
        <div :class="['see_pop_right', 'animated', showAnimated ? 'fadeInRightBig' : 'fadeOutRightBig']">
            <div class="see_title">
               <span>设备</span><span style="color:red;">{{deviceCode}}</span><span>{{getTypeValue(seeType)}}</span>
            </div>

            <see-ad 
              v-if="seeType === 'ad'" 
              :device-code="deviceCode"
              @boxClose="boxClose">
            </see-ad>
            <see-weixin 
              v-if="seeType === 'weixin'" 
              :device-code="deviceCode"
              @boxClose="boxClose">
            </see-weixin>
            <see-pager-record 
              v-if="seeType === 'pageRecord'" 
              :device-code="deviceCode"
              @boxClose="boxClose">
            </see-pager-record>
            <see-device-info  
              v-if="seeType === 'deviceInfo'"
              :device-code="deviceCode"
              @boxClose="boxClose">
            </see-device-info>
            <see-out-paper-record  
              v-if="seeType === 'outPaperRecord'"
              :device-code="deviceCode"
              :the-uuid="theUuid"
              @boxClose="boxClose">
            </see-out-paper-record >

            <span @click="boxClose" 
            style="position: absolute; top: 0;left:0;padding:10px;color:#FF4949">
            <i class="el-icon-close Danger"></i></span>
        </div>
    </div>
</template>
<script>
    import seeAd from '@/page/deviceMgr/seeAd'
    import seeWeixin from '@/page/deviceMgr/seeWeixin'
    import seePagerRecord from '@/page/deviceMgr/seePagerRecord'
    import seeDeviceInfo from '@/page/deviceMgr/seeDeviceInfo'
    import seeOutPaperRecord from '@/page/deviceMgr/seeOutPaperRecord'
    export default {
      props: ['seePopRightOk', 'deviceCode', 'seeType', 'theUuid'],
      data () {
        return {
          showAnimated: true
        }
      },
      computed: {
        seePopRightOkShow: function () {
          this.showAnimated = true
          return this.seePopRightOk
        }
      },
      methods: {
        boxClose () {
          this.showAnimated = false
          var _this = this
          setTimeout(function () {
            _this.$emit('closeSeeRightPop', false)
          }, 500)
        },
        getTypeValue (params) {
          if (params === 'ad') {
            return '广告列表'
          } else if (params === 'weixin') {
            return '公众号列表'
          } else if (params === 'pageRecord') {
            return '补货记录'
          } else if (params === 'deviceInfo') {
            return '设备详情'
          }
        }
      },
      components: {
        'see-ad': seeAd,
        'see-weixin': seeWeixin,
        'see-pager-record': seePagerRecord,
        'see-device-info': seeDeviceInfo,
        'see-out-paper-record': seeOutPaperRecord
      }
    }
</script>
<style lang="scss">
  .see_pop_right_mask {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      position: fixed;
      background: rgba(#000, 0.3);
      z-index: 1000;
  }
  .see_pop_right {
    top: 0;
    right: 0;
    left: 10%;
    bottom: 0;
    z-index: 1001;
    position: fixed;
    background: #eef1f6;

    .see_title {
        background: white; 
        padding: 10px;
        border-bottom: 1px solid #ccc;

        p {
            margin:0;
            padding: 5px;
            color: black;
            font-size: 20px;
            font-weight: 500;
        }
        span {
            margin-right: 5px;
        }
    }
  }

  .animated {
      -webkit-animation-duration: 1s;
      animation-duration: 1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }

    .animated.infinite {
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }

    .animated.hinge {
      -webkit-animation-duration: 2s;
      animation-duration: 2s;
    }

    @-webkit-keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
    }

    @keyframes fadeInRightBig {
      0% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }

      100% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }
    }

    .fadeInRightBig {
      -webkit-animation-name: fadeInRightBig;
      animation-name: fadeInRightBig;
    }

    @-webkit-keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }

    @keyframes findinMask {
      0% {
        opacity: 0;
      }

      100% {
        opacity: 1;
      }
    }
    .findinMask {
      -webkit-animation-name: findinMask;
      animation-name: findinMask;
    }



    @-webkit-keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    @keyframes fadeOutRightBig {
      0% {
        opacity: 1;
        -webkit-transform: translateX(0);
        -ms-transform: translateX(0);
        transform: translateX(0);
      }

      100% {
        opacity: 0.5;
        -webkit-transform: translateX(2000px);
        -ms-transform: translateX(2000px);
        transform: translateX(2000px);
      }
    }

    .fadeOutRightBig {
      -webkit-animation-name: fadeOutRightBig;
      animation-name: fadeOutRightBig;
    }

    @-webkit-keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }

    @keyframes findOutMask {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }
    .findOutMask {
      -webkit-animation-duration: 0.5s;
      animation-duration: 0.5s;
      -webkit-animation-name: findOutMask;
      animation-name: findOutMask;
    }
</style> 


// WEBPACK FOOTER //
// src/page/fxshop/fxPopRight.vue